export default "__VITE_ASSET__CHewxBQ0__"